<template>
    <div>
        <div role="form" class="p-4 m-auto max-w-md kort">
            <div v-if="!bookingAfsendt">
                <section class>
                    <h2>Ansvarlig arrangør</h2>
                    <div>
                        <label>
                            <span>Navn på ansvarlig</span>
                            <input class="form-input" required type="text" name="ansvarlig" autocomplete="name"
                                v-model="Ansvarlig" />
                        </label>
                        <label>
                            <span>Adresse</span>
                            <AdresseSearch v-model="Adresse"></AdresseSearch>
                        </label>
                        <label>
                            <span>E-mail</span>
                            <input class="form-input" required type="email" name="Email" autocomplete="email"
                                v-model="email" />
                        </label>
                        <label>
                            <span>Telefon</span>
                            <input class="form-input" required type="tel" name="Telefonnr" autocomplete="tel"
                                v-model="tlf" />
                        </label>
                        <label>
                            <span>Forening/Virksomhed</span>
                            <input class="form-input" required type="text" name="Forening" autocomplete="organization"
                                v-model="forening" />
                        </label>
                        <label>
                            <span>CVR eller CPR nr.</span>
                            <input class="form-input" required type="text" name="CVRnr" v-model="cvr" />
                        </label>
                    </div>
                </section>

                <section>
                    <h2>Om arrangementet</h2>
                    <label>
                        <span>Arrangementets navn</span>
                        <input class="form-input" type="text" name="navn" v-model="navn" />
                    </label>
                    <label>
                        <span>Areal</span>
                        <select class="form-select" name="FastArealId" v-model="fastArealId">
                            <option v-for="a in Arealer" :value="a.id" :key="a.id">{{ a.properties.navn }}</option>
                        </select>
                    </label>
                    <div class="bg-gray-100 p-4 mt-2"
                        v-show="fastArealBeskrivelse || fastArealEgnethed || fastArealBeliggenhed">
                        <div class>{{ fastArealBeskrivelse }}</div>
                        <div class="mt-4">
                            <h5>Egnethed</h5>
                            {{ fastArealEgnethed }}
                        </div>
                        <div class="mt-4">
                            <h5>Beliggehed</h5>
                            {{ fastArealBeliggenhed }}
                        </div>
                    </div>
                    <a class="my-4 block" @click.prevent="tegn_areal()">Klik her for at tegne et andet areal i
                        kortet</a>
                    <div id="mapid" class="w-full rounded-md max-h-1/2 h-96"></div>
                    <div v-if="InValidGeom" style="color:red">
                        Det areal du har tegnet er ugyldigt. Dette kan skyldes at siderne rammer hinanden. V&aelig;lg
                        eller
                        <a @click.prevent="tegn_areal()">tegn</a> et gyldigt omr&aring;de.
                    </div>
                    <label class>
                        <span>Arrangementtype</span>
                        <select class="form-select" name="ArrangementType" v-model="Arrangementstype">
                            <option v-for="a in Arrangementstyper" :value="a.value" :key="a.value">{{ a.key }}</option>
                        </select>
                    </label>
                    <label>
                        <span>Beskrivelse</span>
                        <textarea rows="6" class="form-textarea" v-model="Beskrivelse"></textarea>
                    </label>
                    <label>
                        <span>Antal deltagere</span>
                        <select class="form-select" name="DeltagerAntal" v-model="DeltagerAntal">
                            <option v-for="d in DeltagerAntaltyper" :value="d.value" :key="d.value">{{ d.key }}</option>
                        </select>
                    </label>
                    <label for>
                        <span>Tilvalg</span>
                    </label>

                    <div v-for="(item, index) in tilvalg" :key="index" class="block bg-gray-100 my-2 rounded-lg">
                        <label class="form-checkbox-label flex items-center space-x-3 p-4">
                            <input type="checkbox" v-model="item.state" :disabled="item.tilladt == false" />
                            <span>{{ item.key }}</span>
                            <span style="color:red">{{ item.forklaring }}</span>
                        </label>
                    </div>
                </section>

                <section>
                    <h2>Tidspunkter</h2>
                    <div class="flex flex-col">
                        <div class="divide-y-2 divide-gray-200 divide-dashed">
                            <div v-for="(t, index) in tidspunkter" :key="t.i" class="py-4">
                                <BookingTidspunkt :tidspunkt="t" :index="index" :tegnetAreal="tegnetAreal"
                                    :fastAreal="computedfastArealId" :num="tidspunkter.length" @fjern="fjern">
                                </BookingTidspunkt>
                            </div>
                        </div>

                        <button class="button" v-on:click.prevent="tilfoej">Tilføj en tid</button>
                    </div>
                </section>

                <section>
                    <div class="block bg-gray-100 my-2 rounded-lg">
                        <label class="form-checkbox-label flex items-center space-x-3 p-4">
                            <input type="checkbox" v-model="AcceptererBetingelse" />
                            <span class="mt-0">
                                Jeg har læst og forstået
                                <a target="_blank" href="Betingelser.html">betingelserne</a>
                                <!--href="http://apps.aalborgkommune.dk/teknisk/TrafikOgVeje/Arealer_udlaan/Betingelser.pdf"-->
                            </span>
                        </label>
                    </div>

                    <div v-if="commitDisabled()">
                        <span class="py-4 block font-semibold">Forespørgsel kan ikke oprettes før alle felter er udfyldt
                            og betingelserne accepteres.</span>
                        <div class="text-red-700" v-if="missingFields">
                            <span class="font-semibold">Du mangler at angive disse informationer:</span>
                            <ul>
                                <li v-if="!ansvarligAngivet">Dit navn</li>
                                <li v-if="!adresseAngivet">
                                    Din adresse
                                    <span class="italic text-xs">prøv evt. at klikke i feltet igen hvis det er
                                        udfyldt</span>
                                </li>
                                <li v-if="!emailAngivet">Din email adresse</li>
                                <li v-if="!cvrAngivet">Dit CVR eller CPR nr.</li>
                                <li v-if="!navnAgivet">Arrangementets navn</li>
                                <li v-if="!arealValgt">Areal som skal reserveres</li>
                            </ul>
                        </div>
                    </div>
                    <button class="button block w-full mt-4" @click.prevent="gem" :disabled="commitDisabled()">Opret
                        forespørgsel</button>
                </section>
            </div>
            <div v-else>
                <h2>Tak for din ansøgning</h2>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import L from "leaflet";
import "leaflet-draw";
import dayjs from "dayjs";
import 'url-search-params-polyfill';
import { rewind } from "../helpers/geojson_righthandrule.js";
import BookingTidspunkt from "./Bookingtidspunkt.vue";
import AdresseSearch from "./AdresseSearch.vue";

export default {
    name: "Kort",
    components: {
        BookingTidspunkt,
        AdresseSearch
    },
    data() {
        return {
            center: [37, 7749, -122, 4194],
            leafmap: null,
            leafDrawControl: null,

            bookingAfsendt: false,

            navn: "",
            Ansvarlig: "",
            forening: "",
            Beskrivelse: "",
            Adresse: "",
            tlf: "",
            email: "",
            cvr: "",

            Arrangementstype: "Andet",
            Arrangementstyper: [
                { value: "Andet", key: "Andet" },
                { value: "Cirkus", key: "Cirkus" },
                { value: "Demonstration", key: "Demonstration" },
                { value: "ForBoern", key: "For Børn" },
                { value: "Koncert", key: "Koncert" },
                { value: "Krydstogtskib", key: "Krydstogtskib" },
                { value: "Marked", key: "Marked" },
                { value: "Musik", key: "Musik" },
                { value: "Oplysning", key: "Oplysning" },
                { value: "Sport", key: "Sport" },
                { value: "Sportsarrangement", key: "Sportsarrangement" },
                { value: "Torvehandel", key: "Torvehandel" },
                { value: "Udstilling", key: "Udstilling" },
            ],
            DeltagerAntal: "_0til50",
            DeltagerAntaltyper: [
                { value: "_0til50", key: "0 til 50" },
                { value: "_50til100", key: "50 til 100" },
                { value: "_100til250", key: "100 til 250" },
                { value: "_250til500", key: "250 til 500" },
                { value: "_500til1000", key: "500 til 1000" },
                { value: "_1000til3000", key: "1000 til 3000" },
                { value: "_3000til10000", key: "3000 til 10000" },
                { value: "over10000", key: "over 10000" },
            ],

            tidspunkter: [
                {
                    i: 1,
                    starttidspunkt: 0,
                    sluttidspunkt: 0,
                    startdato: dayjs().hour(12).format("YYYY-MM-DD"),
                    slutdato: dayjs().hour(12).format("YYYY-MM-DD"),
                },
            ],
            fastArealNavn: "",
            fastArealId: null,
            tegnetAreal: null,
            fastArealBeskrivelse: "",
            fastArealBeliggenhed: "",
            fastArealEgnethed: "",
            fastArealLinkPdf: null,
            fastArealLinkFolder: null,
            fastArealLinkDiverse: null,
            Arealer: [
            ],

            tilvalg: [
                { name: "Lyd", state: false, key: "Forstærket lyd", tilladt: true, forklaring: "" },
                { name: "Stroem", state: false, key: "Strøm", tilladt: true, forklaring: "" },
                { name: "Vand", state: false, key: "Vand", tilladt: true, forklaring: "" },
                { name: "Toilet", state: false, key: "Toilet", tilladt: true, forklaring: "" },
                { name: "Scene", state: false, key: "Opstilling af Scene / Telt", tilladt: true, forklaring: "" },
                { name: "Entre", state: false, key: "Entregivende arrangement", tilladt: true, forklaring: "" },
            ],

            AcceptererBetingelse: false,

            committing: false,
            InValidGeom: false
        };
    },
    computed: {
        booking: function () {
            var tidspunkter = [];
            //for (const tidspunkt of this.tidspunkter) {
            for (var i = 0; i < this.tidspunkter.length; i++) {
                var tidspunkt = this.tidspunkter[i];

                tidspunkter.push({
                    starttidspunkt: this.formatDate(
                        tidspunkt.startdato,
                        tidspunkt.starttidspunkt
                    ),
                    sluttidspunkt: this.formatDate(
                        tidspunkt.slutdato,
                        tidspunkt.sluttidspunkt
                    ),
                });
            }
            // eslint-disable-next-line
            //console.log(tidspunkter);
            var booking = {
                navn: this.navn,
                Beskrivelse: this.Beskrivelse,
                ansvarlig: this.Ansvarlig,
                forening: this.forening,
                Adresse: this.Adresse,
                Telefonnr: this.tlf,
                Email: this.email,
                CVRnr: this.cvr,

                ValgtAreal: this.computedfastArealId ? { id: this.fastArealId } : null,
                TegnetAreal: this.tegnetAreal
                    ? {
                        navn: "Tegnet areal til " + this.navn,
                        geometri: this.tegnetAreal,
                    }
                    : null,

                //{ "type": "Polygon", "coordinates": [[[9.881172, 57.046263], [9.958763, 57.034309], [9.920998, 57.066054], [9.881172, 57.046263]]] },

                Lyd: this.tilvalg.find((item) => item.name == "Lyd").state,
                Stroem: this.tilvalg.find((item) => item.name == "Stroem").state,
                Vand: this.tilvalg.find((item) => item.name == "Vand").state,
                Toilet: this.tilvalg.find((item) => item.name == "Toilet").state,
                Scene: this.tilvalg.find((item) => item.name == "Scene").state,
                Entre: this.tilvalg.find((item) => item.name == "Entre").state,
                AcceptererBetingelse: this.AcceptererBetingelse,

                ArrangementType: this.Arrangementstype,
                DeltagerAntal: this.DeltagerAntal,
                tidspunkter: tidspunkter,
            };
            return booking;
        },
        computedfastArealId: function () { return this.fastArealId == "TegnetAreal" ? null : this.fastArealId; },
        arealValgt: function () {
            return this.computedfastArealId != null || this.tegnetAreal != null;
        },
        navnAgivet: function () {
            return this.booking.navn != "";
        },
        ansvarligAngivet: function () {
            return this.booking.ansvarlig != "";
        },
        adresseAngivet: function () {
            return this.booking.Adresse != "";
        },
        emailAngivet: function () {
            return this.booking.Email != "";
        },
        cvrAngivet: function () {
            return this.booking.CVRnr != "";
        },
        missingFields: function () {
            return !this.navnAgivet ||
                !this.ansvarligAngivet ||
                !this.adresseAngivet ||
                !this.emailAngivet ||
                !this.cvrAngivet ||
                !this.arealValgt;
        }
    },
    methods: {
        setupLeafletMap(callback) {
            // Opsaetning af kort
            var themap = L.map("mapid", {}).setView([57.054363, 9.935172], 12);
            this.leafmap = themap;

            var ticket = "&ticket=" + "e5db669f1026b96998222290557e4425"; // token fra kortforsynigen.dk

            var luftfoto = L.tileLayer
                .wms(
                    "http://kortforsyningen.kms.dk/service?servicename=orto_foraar&service=WMS&version=1.1.1" +
                    ticket,
                    {
                        attribution: "Geodatastyrelsen",
                        layers: "orto_foraar",
                        format: "image/png",
                        transparent: true,
                        version: "1.1.1",
                        crs: L.CRS.EPSG4326,
                        maxNativeZoom: 19,
                        maxZoom: 25,
                    }
                )
                ;//.addTo(themap);

            var skaermkort = L.tileLayer.wms(
                "https://services.drift.kortinfo.net/kortinfo/services/Wms.ashx?Site=Aalborg&Page=Arealbooking&Service=WMS&Version=1.1.1",
                {
                    attribution: "Hexagon",
                    layers: "B3721",
                    format: "image/png",
                    transparent: true,
                    version: "1.1.1",
                    crs: L.CRS.EPSG25832,
                    maxNativeZoom: 19,
                    maxZoom: 25,
                }
            ); //.addTo(themap);

var luftfoto_med_vejnavne = L.tileLayer.wms(
                "https://services.drift.kortinfo.net/kortinfo/services/Wms.ashx?Site=Aalborg&Page=Arealbooking&Service=WMS&Version=1.1.1",
                {
                    attribution: "Hexagon",
                    layers: "B5872",
                    format: "image/png",
                    transparent: true,
                    version: "1.1.1",
                    crs: L.CRS.EPSG25832,
                    maxNativeZoom: 19,
                    maxZoom: 25,
                }
            ).addTo(themap);


            var baseMaps = {
                Luftfoto: luftfoto_med_vejnavne,
                Kort: skaermkort
            };
            //var arealer = L.

            var overlayMaps = {
            };
            L.control.layers(baseMaps, overlayMaps).addTo(themap);

            this.drawnItems = L.featureGroup().addTo(themap); // Tomt lag at tegne i

            var drawcontrol = new L.Control.Draw({
                draw: {
                    // Kun polygoner
                    polygon: {
                        allowIntersection: false,
                        showArea: true,
                    },
                    line: false,
                    polyline: false,
                    marker: false,
                    rectangle: false,
                    circle: false,
                    circlemarker: false,
                },
            });

            this.leafDrawControl = drawcontrol;

            themap.addControl(drawcontrol);

            var app = this;

            themap.on(L.Draw.Event.DRAWSTART, function () {
                //event
                app.drawnItems.clearLayers();
                app.tegnetAreal = null;
                app.fastArealId = "TegnetAreal";
            });

            themap.on(L.Draw.Event.CREATED, function (event) {
                var layer = event.layer;
                //console.log(event.layer)
                app.drawnItems.addLayer(layer);
                var geo = layer.toGeoJSON().geometry;
                app.tegnetAreal = rewind(geo, true); // use rewind to ensure compliance with right hand rule


                fetch(process.env.VUE_APP_API_URL + "/api/ValidGeometry", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(app.tegnetAreal)
                }).then(raw => raw.json()).then(response => {
                    if (response == true) {
                        //app.fastArealId = "TegnetAreal";
                        app.fastArealNavn = "";
                        app.InValidGeom = false;
                        for (var i in app.tilvalg) {
                            app.tilvalg[i].forklaring = "Muligvis ikke muligt på tegnet areal";
                        }
                    } else {
                        app.InValidGeom = true;
                        app.tegnetAreal = null;
                    }
                })
            });

            // Read Arealer, add to map and dropdown
            fetch(process.env.VUE_APP_API_URL + "/api/Arealer").then(raw => raw.json()).then(response => {
                L.geoJSON(response.features, {
                    onEachFeature: app.asignClickHandler,
                })
                    .addTo(themap);
                //console.log(response.data.features);
                var valgtArealParameter = null;
                //console.log('Trying to read provided fastarealId:');
                try {
                    var params = new URLSearchParams(window.location.search);
                    //console.log('Trying to read provided fastarealId:');
                    if (params.has("valgtAreal")) {
                        var valgtArealParameter = params.get("valgtAreal");
                        //console.log('Setting provided fastarealId:' + valgtArealParameter);
                    }
                } catch (e) {
                    //console.log(e);
                }
                for (var f = 0; f < response.features.length; f++) {
                    var feature = response.features[f];
                    //app.Arealer.push({ id: feature.id, name: feature.properties.navn });
                    app.Arealer.push(feature);
                    if (feature.id == valgtArealParameter) {
                        //console.log('Preselecting provided fastarealId:' + valgtArealParameter);
                        app.fastArealId = feature.id;
                    }
                }
                // Add "Tegnet Areal"
                app.Arealer.push({ id: "TegnetAreal", properties: { navn: "Tegnet Areal" } });
                callback()
            })
        },
        tegn_areal: function () {
            this.fastArealId = null;
            this.$nextTick(function () {
                this.fastArealId = "TegnetAreal";
            });


        },
        start_tegning: function () {
            new L.Draw.Polygon(
                this.leafmap,
                this.leafDrawControl.options.polygon
            ).enable();

            this.nulstillTilvalg();
        },
        nulstilAreal: function () {
            this.tegnetAreal = null;
            this.fastArealId = null;
            this.fastArealNavn = "";

            this.nulstillTilvalg();
        },
        nulstillTilvalg: function () {
            for (var i in this.tilvalg) {
                this.tilvalg[i].tilladt = true;
                this.tilvalg[i].forklaring = "";
            }

        },
        tilfoej: function () {
            //console.log("ny fase")
            this.tidspunkter.push({
                starttidspunkt: 0,
                sluttidspunkt: 0,
                startdato: dayjs().hour(12).format("YYYY-MM-DD"),
                slutdato: dayjs().hour(12).format("YYYY-MM-DD"),
                i: this.tidspunkter.length + 1,
            });
        },
        fjern: function (index) {
            this.tidspunkter.splice(index, 1);
            for (var i = 0; i < this.tidspunkter.length; i++) {
                this.tidspunkter[i].i = i;
            }
        },
        commitDisabled: function () {
            if (this.committing) {
                return true;
            }
            return this.missingFields || (!this.booking.AcceptererBetingelse);
        },
        formatDate: function (date, hour) {
            return dayjs(date, "YYYY-MM-DD").hour(hour).minute(0).format('YYYY-MM-DD HH:mm')
            // var tid = dayjs(date);
            // tid.hour(hour).minute(0);
            // return tid.format("YYYY-MM-DD HH:mm");
        },
        asignClickHandler: function (feature, layer) {
            //bind click
            layer.on({
                click: this.areaClicked,
            });
            layer.bindTooltip(layer.feature.properties.navn, { permanent: false, _opacity: 0.5 }

                //function (layer) {
                //return String(layer.feature.properties.navn);//+ "<br> <div style=\"width: 25%\">" + String(layer.feature.properties.Beskrivelse +"<\div>" ); //merely sets the tooltip text
                //}//, { permanent: true, opacity: 0.5 }
            )
        },
        areaClicked: function (event) {
            this.fastArealId = event.target.feature.id;
            this.InValidGeom = false;
        },
        gem: function () {
            // eslint-disable-next-line
            //console.log(this.booking);
            this.committing = true;
            fetch(process.env.VUE_APP_API_URL + "/api/Bookings", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(this.booking)
            }).then(raw => raw.json()).then(response => this.bookingAfsendt = true)
        },
        arealById(id) {
            return this.Arealer.find(a => a.id == id)
        }
    },
    watch: {
        // whenever question changes, this function will run
        fastArealId: function (newId, oldId) {
            this.drawnItems.clearLayers();
            this.tegnetAreal = null;
            if (newId != null) {
                var valgt_areal = this.Arealer.find((areal) => areal.id == newId)
                //Lyd
                var tilvalg = this.tilvalg.find((item) => item.name == "Lyd");
                if (valgt_areal.properties.TilladerLyd == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                //stroem
                tilvalg = this.tilvalg.find((item) => item.name == "Stroem");
                if (valgt_areal.properties.MulighedForStroem == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                // vand
                tilvalg = this.tilvalg.find((item) => item.name == "Vand");
                if (valgt_areal.properties.MulighedForVand == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                // toilet
                tilvalg = this.tilvalg.find((item) => item.name == "Toilet");
                if (valgt_areal.properties.MulighedForToilet == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                // scene
                tilvalg = this.tilvalg.find((item) => item.name == "Scene");
                if (valgt_areal.properties.TilladerScene == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                // entre
                tilvalg = this.tilvalg.find((item) => item.name == "Entre");
                if (valgt_areal.properties.TilladerEntre == true) {
                    tilvalg.tilladt = true;
                    tilvalg.forklaring = "";
                } else {
                    tilvalg.tilladt = false;
                    tilvalg.state = false;
                    tilvalg.forklaring = "Ikke muligt på det valgte areal";
                }
                if (newId != "TegnetAreal") {
                    this.fastArealBeskrivelse = valgt_areal.properties.Beskrivelse;
                    this.fastArealBeliggenhed = valgt_areal.properties.Beliggenhed;
                    this.fastArealEgnethed = valgt_areal.properties.Egnethed;

                    this.fastArealLinkPdf = valgt_areal.properties.LinkPdf;
                    this.fastArealLinkFolder = valgt_areal.properties.LinkFolder;
                    this.fastArealLinkDiverse = valgt_areal.properties.LinkDiverse;
                    // Zoom to area
                    //console.log(valgt_areal);
                    var bounds = [
                        [valgt_areal.bbox[1], valgt_areal.bbox[0]],
                        [valgt_areal.bbox[3], valgt_areal.bbox[2]]
                    ];
                    this.leafmap.flyToBounds(bounds);
                } else {
                    this.fastArealBeskrivelse = "";
                    this.fastArealBeliggenhed = "";
                    this.fastArealEgnethed = "";

                    this.fastArealLinkPdf = null;
                    this.fastArealLinkFolder = null;
                    this.fastArealLinkDiverse = null;
                }
            }
            if (newId == "TegnetAreal") {
                this.start_tegning();
            }
        }
    },
    mounted() {
        this.setupLeafletMap(() => {
            this.fastArealId = this.$route.query.fastarealid
        })
    },
};
</script>

<style scoped>
@import "../assets/css/inputs.css";

section {
    @apply max-w-md mx-auto mb-10 pb-5;
}

section:not(:last-child) {
    @apply border-gray-200 border-b-2;
}

h2,
h3,
h4 {
    @apply text-gray-700;
}
</style>